import { MessageCircle, Phone } from "lucide-react";
import { CONTACT, waLink } from "../../lib/brand";
import { trackWhatsApp } from "../../lib/api";

export const FloatingActions = () => (
  <div className="floating-actions">
    <a className="float-whatsapp" href={waLink()} target="_blank" rel="noreferrer" onClick={() => trackWhatsApp("floating")} data-testid="floating-whatsapp-link"><MessageCircle size={20} /> WhatsApp</a>
    <a className="float-call" href={CONTACT.tel} data-testid="floating-call-link"><Phone size={18} /></a>
  </div>
);
